import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { TextAlignment } from '../types/TextAlignment';

export function composeTextAlignmentClasses(alignment: Adaptive<TextAlignment>): string {
    if (typeof alignment === 'object') {
        return clsx(
            alignment.base && `text-${alignment.base}`,
            alignment.sm && `sm:text-${alignment.sm}`,
            alignment.md && `md:text-${alignment.md}`,
            alignment.lg && `lg:text-${alignment.lg}`,
            alignment.xl && `xl:text-${alignment.xl}`,
            alignment['2xl'] && `2xl:text-${alignment['2xl']}`
        );
    }

    return `text-${alignment}`;
}
